import { postV1 } from '@/common/utils/ajax'

const getQuestion = (verify_type, answer_id) => {
    return postV1('verify_qualification', {
        verify_type,
        answer_id
    })
}

export default {
    getQuestion
}
